import React, { useState } from "react";
import { BsSearch } from "react-icons/bs";
import { IoClose } from "react-icons/io5";
import "./searchStyle.css";

const formatPostDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (isNaN(date.getTime())) {
    return String(value);
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const Search = ({ data, setFilterData }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = () => {
    const raw = searchTerm.trim();
    if (!raw) {
      setFilterData(data);
      return;
    }

    // Use a regex that splits at keys (case-insensitive) but keeps values with spaces
    // We match (key:), and split before it
    const terms = raw.split(/(?=\b(?:taskid|userid|projectid|id|name|account_no|postdate):)/i);

    const filtered = data.filter(item => {
      return terms.every(segment => {
        const seg = segment.trim();
        if (!seg) return true;

        // Lowercase key part for detection
        const segLower = seg.toLowerCase();

        if (segLower.startsWith("name:")) {
          const val = seg.substring(5).trim();  // after "name:"
          return String(item.name || "").toLowerCase().includes(val.toLowerCase());
        }

        if (segLower.startsWith("postdate:")) {
          const val = seg.substring("postdate:".length).trim().toLowerCase();
          const itemDate = formatPostDate(item.postDate).toLowerCase();
          return itemDate === val;
        }

        if (segLower.startsWith("userid:")) {
          const val = seg.substring("userid:".length).trim().toLowerCase();
          return String(item.userid || "").toLowerCase().includes(val);
        }

        if (segLower.startsWith("account_no:")) {
          const val = seg.substring("account_no:".length).trim().toLowerCase();
          return String(item.account_no || "").toLowerCase().includes(val);
        }

        if (segLower.startsWith("id:")) {
          const val = seg.substring(3).trim(); 
          const vals = val.split(",").map(v => v.trim());
          return vals.includes(String(item.id));
        }

        if (segLower.startsWith("taskid:")) {
          const val = seg.substring("taskid:".length).trim().toLowerCase();
          return String(item.taskid || "").toLowerCase().includes(val);
        }

        if (segLower.startsWith("projectid:")) {
          const val = seg.substring("projectid:".length).trim().toLowerCase();
          return String(item.projectid || "").toLowerCase().includes(val);
        }

        const low = seg.toLowerCase();
        const formattedDate = formatPostDate(item.postDate).toLowerCase();
        return (
          String(item.name || "").toLowerCase().includes(low) ||
          String(item.userid || "").toLowerCase().includes(low) ||
          String(item.account_no || "").toLowerCase().includes(low) ||
          String(item.id || "").includes(low) ||
          String(item.taskid || "").toLowerCase().includes(low) ||
          String(item.projectid || "").toLowerCase().includes(low) ||
          formattedDate.includes(low)
        );
      });
    });

    setFilterData(filtered);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSearch();
  };

  const clearSearch = () => {
    setSearchTerm("");
    setFilterData(data);
  };

  return (
    <div className="search-container">
      <div className="search-box">
        <input
          type="text"
          placeholder="Search: name:john userid:abc123"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        {searchTerm && (
          <button className="clear-btn" onClick={clearSearch}>
            <IoClose size={18} />
          </button>
        )}
        <button className="search-btn" onClick={handleSearch}>
          <BsSearch size={18} />
        </button>
      </div>
    </div>
  );
};

export default Search;
